import React from 'react'
import { useAuth } from '../context/AuthContext'
import { useToast } from '../context/ToastContext'
import { COUNTRIES } from '../data/Countries'
import { LANGUAGES } from '../data/Languages'

export default function Profile() {
    const { user, updateProfile } = useAuth()
    const { addToast } = useToast()

    const [firstName, setFirstName] = React.useState(user?.first_name ?? '')
    const [lastName,  setLastName]  = React.useState(user?.last_name  ?? '')
    const [city,      setCity]      = React.useState(user?.city       ?? '')
    const [country,   setCountry]   = React.useState(user?.country    ?? '')
    const [language,  setLanguage]  = React.useState(user?.language   ?? '')
    const [newPassword,     setNewPassword]     = React.useState('')
    const [confirmPassword, setConfirmPassword] = React.useState('')
    const [loading, setLoading] = React.useState(false)

    async function handleSubmit(e) {
        e.preventDefault()

        if (newPassword && newPassword.length < 8) {
            addToast('New password must be at least 8 characters', 'error')
            return
        }
        if (newPassword !== confirmPassword) {
            addToast('Passwords do not match', 'error')
            return
        }

        setLoading(true)
        try {
            await updateProfile({ firstName, lastName, city, country, language, newPassword })
            setNewPassword('')
            setConfirmPassword('')
            addToast('Profile updated', 'success')
        } catch (err) {
            addToast(err.message, 'error')
        } finally {
            setLoading(false)
        }
    }

    const inputClass    = "px-3 py-2 border border-gray-300 rounded-md font-karla text-base outline-none focus:border-bankroll-primary"
    const readonlyClass = "px-3 py-2 border border-gray-200 rounded-md font-karla text-base bg-gray-100 text-gray-500 cursor-not-allowed"
    const labelClass    = "flex flex-col gap-1.5 font-semibold text-sm text-bankroll-text"
    const selectClass   = `${inputClass} bg-white`

    return (
        <main className="flex w-full flex-col items-center justify-start px-5 py-6">
            <div className="bg-white rounded-xl w-full max-w-lg shadow-lg overflow-hidden">
                <div className="px-9 py-4">
                    <form className="flex flex-col gap-3" onSubmit={handleSubmit}>
                        <label className={labelClass}>
                            Username
                            <input className={readonlyClass} type="text" value={user?.username ?? ''} readOnly />
                        </label>

                        <label className={labelClass}>
                            Email
                            <input className={readonlyClass} type="email" value={user?.email ?? ''} readOnly />
                        </label>

                        <div className="flex gap-3">
                            <label className={`${labelClass} flex-1`}>
                                First name
                                <input className={inputClass} type="text" value={firstName} onChange={e => setFirstName(e.target.value)} autoComplete="given-name" />
                            </label>
                            <label className={`${labelClass} flex-1`}>
                                Last name
                                <input className={inputClass} type="text" value={lastName} onChange={e => setLastName(e.target.value)} autoComplete="family-name" />
                            </label>
                        </div>

                        <label className={labelClass}>
                            City
                            <input className={inputClass} type="text" value={city} onChange={e => setCity(e.target.value)} autoComplete="address-level2" />
                        </label>

                        <label className={labelClass}>
                            Country
                            <select className={selectClass} value={country} onChange={e => setCountry(e.target.value)}>
                                <option value="">Select a country…</option>
                                {COUNTRIES.map(c => (
                                    <option key={c} value={c}>{c}</option>
                                ))}
                            </select>
                        </label>

                        <label className={labelClass}>
                            Language
                            <select className={selectClass} value={language} onChange={e => setLanguage(e.target.value)}>
                                <option value="">Select a language…</option>
                                {LANGUAGES.map(l => (
                                    <option key={l} value={l}>{l}</option>
                                ))}
                            </select>
                        </label>

                        <label className={labelClass}>
                            Date of birth
                            <input className={readonlyClass} type="date" value={user?.date_of_birth ?? ''} readOnly />
                        </label>

                        <hr className="border-0 border-t border-gray-200 my-1" />
                        <p className="text-xs text-gray-500 m-0">Leave password fields blank to keep your current password.</p>

                        <label className={labelClass}>
                            New password
                            <input className={inputClass} type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} autoComplete="new-password" />
                        </label>

                        <label className={labelClass}>
                            Confirm new password
                            <input className={inputClass} type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} autoComplete="new-password" />
                        </label>

                        <button
                            className="mt-1 py-3 bg-bankroll-primary text-white border-0 rounded-md font-karla text-base font-bold cursor-pointer hover:bg-bankroll-primary-hov disabled:opacity-60 disabled:cursor-default"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? 'Saving…' : 'Save changes'}
                        </button>
                    </form>
                </div>
            </div>
        </main>
    )
}
